import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '../../auth/auth.guard';
import { MasterResolver } from '../master/master.resolver';
import { UserDetailsComponent } from './user-details/user-details.component';
import { UserEditComponent } from './user-edit/user-edit.component';
import { UserNoSelectedComponent } from './user-no-selected/user-no-selected.component';

import { UsersComponent } from './users.component';
import { BusinessGuard } from 'src/app/auth/business.guard';

const routes: Routes = [
  {
    path: ':business',
    canActivate: [AuthGuard, BusinessGuard],
    resolve: [MasterResolver],
    data: { breadcrumb: 'business' },
    children: [
      {
        path: 'users',
        component: UsersComponent,
        data: { breadcrumb: 'Usuarios' },
        children: [
          { path: '', component: UserNoSelectedComponent },

          {
            path: 'new',
            component: UserEditComponent,
            data: { breadcrumb: 'Nuevo' },
          },

          {
            path: ':id',
            component: UserDetailsComponent,
            data: { breadcrumb: 'Detalle' },
          },

          {
            path: ':id/edit',
            component: UserEditComponent,
            data: { breadcrumb: 'Editar' },
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UsersRoutingModule {}
